import axios from 'axios';
import { serialize } from 'object-to-formdata';

export default {
    fetchAll() {
        return axios.post('/workstationScreen/fetchAll/');
    },
    fetchById(id) {
        return axios.post('/workstationScreen/fetchById/', { id });
    },
    fetchByWorkstationProducttype(workstationId, producttypeId) {
        return axios.post('/workstationScreen/fetchByWorkstationProducttype/', {
            workstationId,
            producttypeId,
        });
    },
    createWorkstationScreen(payload) {
        return axios.post(
            '/workstationScreen/createWorkstationScreen',
            payload
        );
    },
    updateWorkstationScreen(payload) {
        return axios.post(
            '/workstationScreen/updateWorkstationScreen',
            serialize(payload)
        );
    },
};
